<template>
  <span
    v-if="pending"
    class="mx-2 h-5 w-20 animate-pulse rounded-md bg-muted-foreground"
  >
  </span>
  <Menu.Root v-else>
    <Menu.Trigger :disabled="crumbs.length === 1">
      <button
        v-bind="$attrs"
        type="button"
        class="flex min-w-0 select-none items-center gap-3 rounded-full px-2 py-[0.3125rem] text-sm font-bold outline-2 outline-action transition focus-visible:outline disabled:cursor-auto disabled:opacity-100"
        :class="[
          crumbs.length !== 1 &&
            `hover:bg-gray-200 active:bg-gray-200 data-[state=open]:bg-gray-200 dark:hover:bg-card dark:active:bg-card dark:data-[state=open]:bg-card`,
        ]"
      >
        <div
          v-if="last.image"
          class="size-4 shrink-0 overflow-hidden rounded-md"
        >
          <img :src="last.image" class="size-full object-cover" />
        </div>
        <component
          :is="iconMappingMicro[last.icon]"
          v-else-if="typeof last.icon === 'string'"
          class="size-4 shrink-0 text-purple-500"
        />
        <component
          :is="last.icon"
          v-else-if="last.icon"
          class="size-4 shrink-0 text-purple-500"
        />

        <span class="truncate" role="heading" aria-level="1">{{
          last.title
        }}</span>

        <ChevronDownIcon
          v-if="crumbs.length !== 1"
          class="-ml-1 -mr-0.5 size-4 shrink-0 text-muted-foreground"
        />
      </button>
    </Menu.Trigger>

    <Menu.Container align="start">
      <template v-for="(item, idx) in crumbs" :key="idx">
        <Menu.RouteItem
          v-if="item.from"
          :label="item.title"
          :icon="typeof item.icon === 'string' ? item.icon : undefined"
          :to="item.from"
        />
        <Menu.Item
          v-else
          :label="item.title"
          :icon="typeof item.icon === 'string' ? item.icon : undefined"
        />
      </template>
    </Menu.Container>
  </Menu.Root>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Menu from "@/design_system/Menu";
import ChevronDownIcon from "@/icons/heroicons/chevron-down-micro.svg";
import { iconMappingMicro } from "@/icons/icon-mapping-micro";

import type { BreadcrumbPath } from "./breadcrumb-types";

const props = defineProps<{
  crumbs: BreadcrumbPath;
  pending?: boolean;
}>();

const last = computed(() => {
  return props.crumbs.at(-1)!;
});
</script>
